import { useMemo } from "react";

import type { InSaleAndStopSellingItemsType } from "../../../../_shared";
import type { ServerModel } from "../../../model/usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
};

export const useCreateInSaleAndStopSellingFilterProps = ({ serverModel }: Props) => {
	const { items } = serverModel.roomStock;

	const inSaleItems: InSaleAndStopSellingItemsType = useMemo(
		() =>
			items
				.filter((item) => item.isInSale)
				.map((item) => {
					return { id: item.roomID, name: item.name };
				}),
		[items],
	);

	const stopSellingItems: InSaleAndStopSellingItemsType = useMemo(
		() =>
			items
				.filter((item) => !item.isInSale)
				.map((item) => {
					return { id: item.roomID, name: item.name };
				}),
		[items],
	);

	return {
		itemsName: "部屋" as const,
		inSaleItems,
		stopSellingItems,
	};
};
